export default {
  TTL_APPLICATION: 'Aviation Services',
  TTL_FLIGHTS_CALENDAR: 'Calendar',

  TTL_PAGE_ACCESS_DENIED: 'Access Denied!',

  TTL_ADMIN: 'Admin',
  TTL_ADMIN_ADD: 'Add Admin',
  TTL_ADMIN_USERS: 'Admin Users',
  TTL_ADMIN_CONFIGURATION_SETTINGS: 'Configuration Settings',
  TTL_ADMIN_EMPLOYEE_SEARCH: 'Employee Search',
  TTL_ADMIN_FIRE_AGENCIES: 'Fire Agencies',
  TTL_ADMIN_FLIGHT_OPERATORS: 'Flight Operators',
  TTL_ADMIN_FLIGHT_TYPES: 'Flight Types',
  TTL_ADMIN_SENSITIVE_CITIES: 'Sensitive Cities',
  TTL_ADMIN_OPERATORS_AND_PILOTS: 'Operator and Pilot Relationships',
  TTL_ADMIN_OPERATORS_AND_TAILS: 'Operator and Tail Number Relationships',
  TTL_ADMIN_SENSITIVE_COMMUNITIES: 'Sensitive Communities',
  TTL_ADMIN_PILOTS: 'Pilots',
  TTL_ADMIN_ROLE_MAINTENANCE: 'Role Maintenance',
  TTL_ADMIN_ROPE_SIZE_AND_CONDUCTORS: 'Rope / Conductor Sizes',
  TTL_ADMIN_SURVEY_QUESTIONS: 'Survey Questions',
  TTL_ADMIN_TAIL_NUMBERS: 'Tail Numbers',
  TTL_ADMIN_DISTRICT_PROJECTS: 'Districts and Projects',
  TTL_ADMIN_DEPARTMENT: 'Departments',
  TTL_ADMIN_POLYGON: 'Polygons',
  TTL_ADMIN_DRONE_AREAS: 'Sensitive Drone Areas',

  TTL_AVIATION_SERVICE: 'Aviation Services',
  TTL_AVIATION_SERVICE_REQUEST: 'Aviation Services Request',
  TTL_FIRE_DISPATCH_DISPATCH: 'Fire Dispatch',
  TTL_AVIATION_SERVICE_DISPATCH: 'Fire Dispatches',
  TTL_NEW_FIRE_DISPATCH_FORM: 'New Fire Dispatch Form',
  TTL_FIRE_DISPATCH_FORM_INFORMATION: 'Dispatch Information',
  TTL_FIRE_DISPATCH_FLIGHT_INFORMATION: 'Flight Information',
  TTL_FIRE_DISPATCH_FIRE_INFORMATION: 'Fire Information',
  TTL_FIRE_DISPATCH_FIRE_DISPATCH_STATUS: 'Fire Dispatch Status',
  TTL_FIRE_DISPATCH_FINANCIAL_DETAILS: 'Financial Details',

  TTL_HOME: 'Home',
  TTL_FLIGHT_REQUEST: 'Flight Requests',
  TTL_FLIGHT_REQUEST_NEW: 'New Flight Request',
  TTL_FLIGHT_REQUEST_DUPLICATE: 'Duplicate Flight Request',

  TTL_MANAGE_ROPE_SIZE_CONDUCTOR: 'Rope/Conductor Sizes',

  TTL_TOAST_ERROR: 'Error',
  TTL_TOAST_SUCCESS: 'Success',
  TTL_TOAST_WARNING: 'Warning',
  TTL_TOAST_INFO: 'For your information',
  TTL_CONFIRM_STATUS_CHANGE: 'Confirm Status Change',
  TTL_CONFIRM_DELETE: 'Confirm Delete',

  TTL_REMOVE_ADMIN_ACCESS: 'Delete',

  TTL_OPERATOR_PILOT_RELATIONSHIP: 'Operator and Pilot Relationships',
  TTL_OPERATOR_TAIL_NUMBER_RELATIONSHIP:
    'Operator and Tail Number Relationships',
  TTL_DISTRICT_PROJECTS_COMPANY_RELATIONSHIP:
    'District/Project Company Relationships',

  TTL_REQUEST_REQUESTOR_INFORMATION: 'Requestor Information',
  TTL_REQUEST_EMERGENCY_POC: 'Emergency/Incident Point of Contact',
  TTL_REQUEST_REQUESTOR_FEILD_CONTACT: 'Field Contact Information',
  TTL_REQUESTOR_IS_FIELD_CONTACT: 'Requestor is also the field contact.',
  TTL_REQUEST_DATE_TIME: 'Date and Time',
  TTL_REQUEST_ACCOUNTING: 'Accounting Information',
  TTL_NOTIFICATIONS: 'Notifications',
  TTL_REQUEST_FLIGHT_INFORMATION: 'Flight Information',
  TTL_REQUEST_FLIGHT_AIR_DROPS: 'Air Drops',
  TTL_REQUEST_FLIGHT_EDIT_COST: 'Edit Flight Cost',

  TTL_ADDITIONAL_MULTI_FLIGHT_DETAILS: 'Additional Flight Details',
  TTL_FLIGHT_DATE_TIME: 'Flight Date & Time',
  TTL_FLIGHT_REQUEST_STATUS: 'Flight Request Status',
  TTL_ADDITIONAL_FLIGHT_DATE_TIME: 'Additional Flight Date & Time',

  TTL_REQUEST_PATROL_PASSENGER: 'Patrol/Passenger Flight - SCG',
  TTL_REQUEST_PATROL_PASSENGER_CONTRACTOR:
    'Patrol/Passenger Flight - Contractor',
  TTL_REQUEST_CONSTRUCTION: 'Construction Work - SCG',
  TTL_REQUEST_CONSTRUCTION_CONTRACTOR: 'Construction Work - Contractors',

  TTL_FILES: 'Files',
  TTL_FILE_MANAGER: 'File Manager',
  TTL_FILE_MANAGER_UPLOADER: '{0} Upload file',

  TTL_PLAN_OPERATIONS: 'Plan of Operations',
  TTL_CONTACT_INFORMATION: 'Contact Information',
  TTL_WORK_SCOPE: 'Work Scope',
  TTL_BRIEF_DESCRIPTION: 'Brief Job Description or Comments',
  TTL_LANDING_ZONE_COORDINATES: 'Landing Zone Coordinates',
  TTL_AIRCRAFT_INFORMATION: 'Aircraft Information',
  TTL_DRONE_FLIGHT_SCG: 'Drone Flight - SCG',
  TTL_DRONE_FLIGHT_CONTRACTOR: 'Drone Flight - Contractor',
  TTL_DETAILS: 'Details',
  TTL_TAR: 'TAR',
  TTL_CHECKLIST: 'Checklist',

  TTL_FORM_VALIDATION_ERROR: 'There were some errors with your submission',

  TTL_RISK_ASSESSMENT: 'Aviation Services - Risk Assessment Matrix',
  TTL_RISK_ASSESSMENT_FLIGHT_NO: 'For Flight Request No:',

  TTL_DUPLICATE_REQUEST: 'Duplicate Request',

  TTL_TICKET_FILE_DOCUMENT: 'Ticket No. {0} - Supporting Files/Documents',
};
